import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    key: String,
    hideDays: { type: Number, default: 7 }
  }

  connect() {
    const saved = localStorage.getItem(this.keyValue)
    if (saved) {
      try {
        const { expiresAt } = JSON.parse(saved)
        const now = new Date().getTime()

        if (now < expiresAt) {
          this.element.remove()
        } else {
          localStorage.removeItem(this.keyValue)
          this.show()
        }
      } catch {
        localStorage.removeItem(this.keyValue)
        this.show()
      }
    } else {
      this.show()
    }
  }

  hide() {
    const expiresAt = new Date().getTime() + this.hideDaysValue * 24 * 60 * 60 * 1000
    localStorage.setItem(this.keyValue, JSON.stringify({ expiresAt }))
    this.element.remove()
  }

  show() {
    this.element.classList.remove("hidden")
  }
}
